import { createType } from 'framework/utils/createType';

export const ColorXs = createType('default', 'primary', 'secondary', 'error', 'info', 'success', 'warning');
export type ColorX = typeof ColorXs[number];
